module.exports = __webpack_public_path__ + "img/626e812.svg";